<template>
	<div id="enterprise_detail">
		<leftnav class="fl"></leftnav>
		<div class="index_left"
			:style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="enterprise_detail">
					<div class="whitebox">
						<div class="d_blocktitle">
							<i class="title-icon title-icon1"></i>
							<h3 class="ctitle">{{ companyinfor.name }}<span
									v-if="companyinfor.fullName != ''">（{{ companyinfor.fullName }}）</span></h3>
							<!-- <span :class="companyinfor.collectId == 0 ? 'collectbtn add fr' : 'collectbtn remove fr'"
								@click="listToggleCollect(companyinfor, 'acoc')">{{ companyinfor.collectId ==
									0 ? '+添加关注' : '取消关注' }}</span> -->
						</div>
						<p class="companyinfor oh companyinfor4">
							<span class="fl"><i>机构类型：</i><em>{{ companyinfor.type }}</em> </span>
							<span class="fl"><i>成立日期：</i><em>{{ companyinfor.createTime }}</em> </span>
							<span class="fl"><i>总部地区：</i><em>{{ companyinfor.area }}</em> </span>
							<!-- <span class="fl"><i>战绩：</i><em>{{companyinfor.profit}}%</em> </span> -->
						</p>
						<p class="companyinfor oh companyinfor4">
							<span class="fl"><i>管理规模：</i><em v-html="companyinfor.asset == '' ? '-' : companyinfor.asset"></em>
							</span>
							<span class="fl"><i>投资阶段：</i><em>{{ companyinfor.stage }}</em> </span>
							<span class="fl"><i>项 目 数：</i><em>{{ companyinfor.projectCount }}</em> </span>
							<span class="fl "><i class="bihspan">进入下一轮项目数：</i><em>{{ companyinfor.nextRound }}</em>
							</span>
						</p>
						<p class="companyinfor oh companyinfor4" v-show="companyinfor.insurePerson > 0">
							<span class="fl"><i>注册资本：</i><em>{{ companyinfor.regCapital }}</em> </span>
							<span class="fl"><i>所属行业：</i><em>{{ companyinfor.industry }}</em> </span>
							<span class="fl"><i>员工人数：</i><em>{{ companyinfor.insurePerson }}</em> </span>
						</p>
						<p class="companyinfor oh companyinfor4" v-show="companyinfor.insurePerson > 0">
							<span class="fl"><i>组织机构代码：</i><em>{{ companyinfor.orgCode }}</em> </span>
							<span class="fl"><i>注册号：</i><em>{{ companyinfor.regNo }}</em> </span>
							<span class="fl"><i>纳税人识别号：</i><em>{{ companyinfor.taxNo }}</em> </span>
						</p>
						<p class="companyinfor oneline" v-show="companyinfor.businessScope != ''">
							<i>经营范围：</i><em>{{ companyinfor.businessScope }}</em>
						</p>
						<p class="companyinfor oneline">
							<i>机构简介：</i><em>{{ companyinfor.summary }}</em>
						</p>
					</div>
					<div class="de_floorlist1 ende_floorlist" style="width:100%">
						<div class="ende_floorlistfixed" :style="isCollapse ? 'width:100%;left:0' : ''">
							<ul class="oh">
								<li class="floorlistLi" v-show="companyinfor.insurePerson > 0" @click="floorScroll(0)">
									联系方式</li>
								<li class="floorlistLi" v-show="companyinfor.notion != ''" @click="floorScroll(1)">投资领域
								</li>
								<li class="floorlistLi" @click="floorScroll(2)">投资机构画像</li>
								<li class="floorlistLi" @click="floorScroll(3)">投资事件</li>
							</ul>
						</div>
					</div>
					<div class="whitebox company-contact" 
						v-show="companyinfor.insurePerson > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon2"></i>
							<h3 class="title">联系方式</h3>
						</div>
						<p class="companyinfor oh">
							<span class="fl"><i>法定代表人：</i><em>{{ companyinfor.legalPerson }}</em> </span>
							<span class="fl"><i>联系电话：</i><em>{{ companyinfor.phone }}</em> </span>
							<span class="fl"><i>更多电话：</i><em>{{ companyinfor.morePhone }}</em>
							</span>
						</p>
						<div class="enprise_websitebox" v-show="rwebsite" @click="rwebsite = false">
							<div class="enprise_website">
								<h2>您即将跳转进入第三方网站</h2>
								<p class="website_tips"><b>产业大脑</b>不对该网站内容及真实性负责，请注意您的账户和财产安全</p>
								<p class="website_text">{{ companyinfor.website }}</p>
								<span class="router_website" @click="openExternalLink(companyinfor.website)">继续前往</span>
							</div>
						</div>
						<p class="companyinfor oh">
							<span class="fl com_website" @click="rwebsite = true;"><i>网
									址：</i><em>{{ companyinfor.website }}</em> </span>
							<span class="fl"><i>联系邮箱：</i><em>{{ companyinfor.email }}</em> </span>
							<span class="fl"><i>更多邮箱：</i><em>{{ companyinfor.moreEmail }}</em> </span>
						</p>
						<p class="companyinfor oneline">
							<i>企业地址：</i><em>{{ companyinfor.address }}</em>
						</p>
					</div>
					<div class="whitebox company-tags" v-show="companyinfor.notion != ''">
						<div class="d_blocktitle d-floortitle">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">投资领域</h3>
						</div>
						<div class="flexcss">
							<freeUserTips :type="4" :bgtype="36"></freeUserTips>
						 </div>
					</div>
					<div class="whitebox company-tags" >
						<div class="d_blocktitle d-floortitle" data="2">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">投资机构画像</h3>
						</div>
						<div class="flexcss">
							<freeUserTips :type="4" :bgtype="37"></freeUserTips>
						 </div>
					</div>
					<div class="whitebox company-investinfor">
						<div class="d_blocktitle d-floortitle" data="3">
							<i class="title-icon title-icon8"></i>
							<h3 class="title">投资事件</h3>
						</div>
						<div class="flexcss">
							<freeUserTips :type="4" :bgtype="38"></freeUserTips>
						 </div>
					</div>
				</div>
			</div>
		</div>
		<!-- 导出列表弹框 -->
		<div class="enlistexportPop" v-show="exportpop">
			<div class="enlistexportPop_box">
				<h5 class="title">产业大脑为您找到<span class="searchnum">{{ investList.length }}</span>条相关结果</h5>
				<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
				<p class="tips">本次可导出<b class="redfont">{{ investList.length > 500 ? 500 : investList.length }}</b>条，今日剩余次数<b
						class="redfont">{{ companyinfor.exportRemainder }}</b>次</p>
				<span class="determinebtn" @click="exportInvestList()">{{ confirmtext }}</span>
				<span class="closebtn" @click="exportpop = false; exportbtn = true"></span>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</template>

<script>
import investLinePie from "../enterpriseInc/investLinePie.vue"
import { financing_rounds, order_list } from '@/utils/enterprise-tag.js'
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'institutionDetail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			enterprise_id: 0,
			companyinfor: {},
			investList: [],//投资事件
			investList_default: [],//初始化投资事件 不能变动 用来提数据的
			detail_extend: { province: [], city: [], year: [], month: [] },//echart数据
			flag: false, //ehcart数据开关
			notion_tree_list: [{ count: 1, label: "", ochild: [], show_more: false, value: "" }], //投资领域
			floorlist: ['联系方式', '投资领域', '投资事件'],
			tagarrylist: [{
				name: "机构类型",
				children: ['天使机构', 'VC', 'PE', 'CVC', 'FA', 'FOF', '金融机构', '国资背景', '天使个人']
			},
			{
				name: "投资阶段",
				children: ['种子期', '初创期', '成长期', '成熟期']
			},
			{
				name: "特色标签",
				children: ['知名投资机构', 'TOP50投资机构', 'TOP10投资机构', '投资项目多', '战绩高']
			},
			],
			tagtreelist: [],
			barHeight: 60,
			rwebsite: false, // 机构网页跳转提示框
			finacingRound: [],//融资轮次
			finacingMoney: [
				{ label: '全部', id: 1, min: 0, max: 0 },
				{ label: '10亿以上', id: 2, min: 1000000000, max: 0 },
				{ label: '5-10亿', id: 3, min: 500000000, max: 1000000000 },
				{ label: '1-5亿', id: 4, min: 100000000, max: 500000000 },
				{ label: '5000万-1亿', id: 5, min: 50000000, max: 100000000 },
				{ label: '1000万-5000万', id: 6, min: 10000000, max: 50000000 },
				{ label: '1000万以下', id: 7, min: 0, max: 9999999 },
			],//融资时间
			finacingTime: [
				{ label: '全部', id: 1, value: 0 },
				{ label: '2024', id: 2, value: 2024 },
				{ label: '2023', id: 3, value: 2023 },
				{ label: '2022', id: 4, value: 2022 },
				{ label: '2021', id: 5, value: 2021 },
				{ label: '2020', id: 6, value: 2020 },
				{ label: '2019', id: 7, value: 2019 },
				{ label: '2018', id: 8, value: 2018 },
				{ label: '2017', id: 9, value: 2017 },
				{ label: '2016', id: 10, value: 2016 },
				{ label: '2015', id: 11, value: 2015 },
				{ label: '其他', id: 11, value: -1 },

			],//融资金额 
			round_str: '',
			money_id: 1,
			dimensionNum: [0, 1, 2, 3],//排序内容
			dimensionList: [],//排序名字
			exportbtn: true,//是否支持导出
			exportpop: false,//显示导出弹框
			iframeurl: '',//导出的列表iframe链接
			confirmtext: "确认导出",
			invest_screen: { id: 0, round: "", minAmount: 0, maxAmount: 0, year: 0, province: 0, city: 0, notionCode: "", orderType: 0, resultType: 0 },
		}
	},
	components: {
		investLinePie
	},
	beforeCreate() { },
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
		this.bus.$emit('loading', true);
		this.finacingRound = financing_rounds();
		this.dimensionList = order_list(this.dimensionNum);
		this.enterprise_id = this.$route.query.id;
		this.invest_screen.id = this.$route.query.id;
		this.getPageDetail();
	},
	mounted() {
		window.scrollTo(0, 0);
		window.addEventListener("scroll", this.handleScroll, true);
	},
	methods: {
		slideNotion(list) {
			// list.ochild=[]; 
			// this.notion_tree_list=[]; 
			// for(var a=0;a<this.notion_tree_list.length;a++){
			// 	this.notion_tree_list[a].show_more=true;
			// 	this.notion_tree_list[a].label='a';//我也不知道为什么要这么子 不这样show_more就无法生效
			// }
			// console.log(this.notion_tree_list,list.show_more);
			list.show_more = !list.show_more
			// console.log(this.notiontreelist[ind]) 
			// this.notiontreelist[ind].num++;
			// this.notiontreelist[ind].show_more=true;
		},
		getinvestOrgList(type, value) {
			value = value == '全部' ? '' : value;
			if (type == 'money') {
				this.invest_screen.minAmount = value.min;
				this.invest_screen.maxAmount = value.max;
				this.money_id = value.id;
			} else {
				this.invest_screen[type] = value;
			}
			// this.submitParmeter();
		},
		tagrouterNew(type, code, name) {
			var eid = this.enterprise_id;
			let routeUrl = this.$router.resolve({
				path: '/enterpriseTag', query: { type: 8, key: type, id: code, keyword: name, eid: eid }
			});
			window.open(routeUrl.href, '_blank');
		},
		submitParmeter() {
			this.invest_screen.resultType = 0;
			console.log(this.invest_screen);
			var ajaxurl = this.$api.free.investorg.enterpriseList(this.invest_screen);
			var that = this;
			this.$axios.get(ajaxurl).then(function (res) {
				console.log(res.data)
				if (res.data.success) {
					that.investList = res.data.list;
				}
			})
		},
		openExportPop() {
			if (this.exportbtn) {
				this.exportbtn = false;
				this.exportpop = true;
			}
		},
		exportInvestList() {
			var that = this;
			this.invest_screen.resultType = 2;
			console.log(this.invest_screen);
			var ajaxurl = this.$api.cyl.investorg.enterpriseList(this.invest_screen) + '&token=' + this.userdata.token;
			// var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export()) + '&token=' + this.userdata.token;
			this.confirmtext = "导出中";
			var iframe = document.getElementById("exportIframe");
			iframe.setAttribute("src", ajaxurl);
			this.companyinfor.exportRemainder = this.companyinfor.exportRemainder--;
			setTimeout(() => {
				that.confirmtext = "导出成功";
				that.exportpop = false;
				that.exportbtn = false;
			}, 5000)
			setTimeout(() => {
				that.exportbtn = true;
				that.confirmtext = "确认导出";
				// console.log('一分钟冷却计时')
			}, 60000)
		},
		//企业网址跳转
		openExternalLink(url) {
			window.open(url, "_blank");
		},
		//省份城市选择
		cityScreenFun(pid, cid, cuid) {
			this.invest_screen.province = pid;
			this.invest_screen.city = cid;
			// this.invest_screen.province = cuid;  
			this.submitParmeter();
		},
		//概念单选 层级显示
		chooseNotion(chooseNotionlist, notionCode) {
			this.invest_screen.notionCode = notionCode;
			this.submitParmeter();
		},
		//排序 从大到小
		sortKey(array, key, type) {
			type = type ? type : 1;
			var arry1 = array.sort(function (a, b) {
				var x = a[key];
				var y = b[key];
				if (type == 1) {
					return ((x > y) ? -1 : (x < y) ? 1 : 0)
				} else {
					return ((x < y) ? -1 : (x > y) ? 1 : 0)
				}
			})
			return arry1;
		},
		getPageDetail() {
			var that = this;
			this.$axios.get(this.$api.free.investorg.get() + "?id=" + this.enterprise_id).then(function (res) {
				if (res.data.success) {
					// console.log(res.data.data);
					document.title = res.data.data.name;
					that.companyinfor = res.data.data; //基础信息   
					that.detail_extend = res.data.extend;  //饼图折线图
					that.getNotionTreeList(res.data.data.notionTree);//投资领域
					that.getTagChainList(that.companyinfor.tag, that.companyinfor.tagCode); //投资画像
					that.investList = that.sortKey(res.data.data.investList, 'time'); ////投资事件按事件排序
					that.investList_default = that.investList; ////投资事件按事件排序


					// that.companyinfor.notionlist = that.taglistfun(that.companyinfor.notion, that.companyinfor.notionCode);

					setTimeout(function () {
						that.barHeight = document.getElementsByClassName('ende_floorlist')[0].offsetHeight;
						that.bus.$emit('loading', false);
					}, 1000);
					that.flag = true;
				} else {

				}
			})
		},
		//测试title的问题
		testFloorTitle() {
			// console.log(document.getElementsByClassName('d-floortitle').length, document.getElementsByClassName('floorlistLi').length)
			for (var i = 0; i < document.getElementsByClassName('d-floortitle').length; i++) {
				console.log(document.getElementsByClassName('d-floortitle')[i], document.getElementsByClassName(
					'floorlistLi')[i]);
			}
		},
		//监测楼层滚动函数
		handleScroll: function (e) {
			var enflolength = document.getElementsByClassName('ende_floorlistfixed').length;
			// console.log('enflolength1',enflolength)
			if (enflolength < 1) {
				return;
			}
			var sctop = document.documentElement.scrollTop;
			var bartop = document.getElementsByClassName('ende_floorlist')[0].offsetTop;
			// console.log(sctop,bartop);
			if (sctop < bartop) {
				document.getElementsByClassName('ende_floorlistfixed')[0].className = "ende_floorlistfixed";
			} else {
				document.getElementsByClassName('ende_floorlistfixed')[0].className =
					"ende_floorlistfixed fixedbox";
				var lengtsd = document.getElementsByClassName('floorlistLi').length;
				// console.log(lengtsd,document.getElementsByClassName('d-floortitle').length )
				for (var i = 0; i < lengtsd; i++) {
					// console.log(document.getElementsByClassName('d-floortitle')[i],document.getElementsByClassName('d-floortitle')[i+1])
					var top1 = document.getElementsByClassName('d-floortitle')[i].offsetTop - this.barHeight;
					if (i < lengtsd - 1) {
						var top2 = document.getElementsByClassName('d-floortitle')[i + 1].offsetTop - 11 - this
							.barHeight;
						if (top1 > 0 && top2 > 0 && sctop > top1 && sctop < top2) {
							this.floorScroll(i, 'scroll');
						}
					} else if (i == lengtsd - 1) {
						if (top1 > 0 && sctop > top1) {
							this.floorScroll(i, 'scroll');
						}
					}
				};
			}
		},
		//楼层滚动函数
		floorScroll(indexs, type) {
			// console.log(indexs,type);
			var oftop = document.getElementsByClassName('d-floortitle')[indexs].offsetTop - this.barHeight + 6;
			var lengtsd = document.getElementsByClassName('floorlistLi').length;
			// console.log('floorsrcoll',lengtsd);
			for (var i = 0; i < lengtsd; i++) {
				var classNameaf = "floorlistLi";
				if (i == indexs) {
					classNameaf = "floorlistLi current";
				}
				document.getElementsByClassName('floorlistLi')[i].className = classNameaf;
			}
			if (type != 'scroll') {
				// console.log('非',type,oftop);
				window.scrollTo(0, oftop);
			}
			if (type == 'test') {
				this.testFloorTitle();
			}
		},
		//投资画像的标签分类
		getTagChainList(tagname, tagcode) {
			var localchain = this.tagarrylist;
			var reschain = [];
			var ddtaglist = this.taglistfun(tagname, tagcode);
			// console.log(localchain,ddtaglist);
			for (var i = 0; i < localchain.length; i++) {
				var localcsm = localchain[i];
				var reschainsm = {
					name: localchain[i].name,
					children: []
				};
				// reschainsm.name=localchain[i].name,reschainsm.children=[];
				for (var d = 0; d < localcsm.children.length; d++) {
					// reschainsm.children=[];
					var dstring = localcsm.children[d];
					for (var t = 0; t < ddtaglist.length; t++) {
						var tstring = ddtaglist[t].name
						// console.log(dstring , tstring)
						if (dstring == tstring) {
							localcsm.children[d] = 'match';
							// console.log(d)
							reschainsm.children.push({
								id: ddtaglist[t].id,
								name: tstring
							});
						}
					}
				}
				reschain.push(reschainsm);
			}
			this.tagtreelist = reschain;
		},
		//投资领域的概念分类
		getNotionTreeList(data) {
			let aary1 = [];
			//所有大行业并集到一起
			for (var i = 0; i < data.length; i++) {
				if (data[i].children) {
					for (var d = 0; d < data[i].children.length; d++) {
						data[i].children[d].show_more = false;
						data[i].children[d].num = 1;
						aary1.push(data[i].children[d]);
					}
				}
			}
			//将所有等级并集到一起
			for (var i = 0; i < aary1.length; i++) {
				let aary2 = aary1[i].children;
				// aary1[i].show_more = false;
				aary1[i].ochild = [];
				if (aary2) {
					let res = []
					const fn = (source) => {
						source.forEach(el => {
							res.push(el)
							el.children && el.children.length > 0 ? fn(el.children) : ""
						})
					};
					fn(aary2);
					aary1[i].ochild = res;
				}
			}
			console.log('getNotionTreeList', aary1);
			this.notion_tree_list = aary1.filter(list => {
				return list.ochild.length > 0;
			});
		},
	}
}
</script>

<style>.endsm_title2 {
	border-left: 8px solid #3e7bfa;
	line-height: 20px;
	padding-left: 14px;
	margin: 30px 0 30px;
}</style>